import { useContext } from "react";
import { RevenueCard } from "@/components/RevenueCard";
import { MoneyIcon } from "@/components/icons/money-icon";
import { TransactionTable } from "../transaction/TransactionTable";
import { FinanceFilter, FinanceFilterContext } from "@/modules/finance/helper/context/finance-filter.context";
import { Trend } from "@/components/Trend";
import { useAppTabState } from "@/modules/finance/helper/hooks/use-app-tab-state";
import { AppPaymentChart } from "./AppPaymentChart";
import { PieChartComponent } from "./PieChartComponent";
import { EuroIcon, TicketIcon, UserIcon } from "@/components/icons";
import { Skeleton } from "@/components/ui/skeleton";
import { CityContext } from "@/contexts/city-context-provider";
import { PieChart } from "@/modules/finance/helper/types/pie-chart-props.type";

export const AppTabContent = () => {
  const { startDate, endDate } = useContext(FinanceFilterContext) as FinanceFilter;
  const { currentCity } = useContext(CityContext);

  const {
    paymentMethodPieChartData,
    zoneNamePieChartData,
    userProfilesPieChartData,
    averageAmountPerTransaction,
    amountVariation,
    transactionVariation,
    averageAmountPerTransactionVariation,
    activeUsersVariation,
    totalAmount,
    numberOfTransactions,
    activeUsers,
    summaryChartOptions,
    loading,
  } = useAppTabState(currentCity?.id, startDate, endDate);

  const getValueOrSkeleton = (value: string | number) => {
    if (loading) {
      return <Skeleton className="h-5 w-8" />;
    }

    return value;
  };

  const paymentMethodChart: PieChart = {
    title: "Mode de paiement",
    chartOptions: paymentMethodPieChartData,
  };

  const zoneNameChart: PieChart = {
    title: "Zones de paiement",
    chartOptions: zoneNamePieChartData,
  };

  const userProfilesPieChart: PieChart = {
    title: "Profils utilisateurs",
    chartOptions: userProfilesPieChartData,
  };

  return (
    <div className="flex flex-col gap-4 w-full overflow-auto">
      <div className="flex justify-between gap-4">
        <RevenueCard
          title="Total"
          subTitle={getValueOrSkeleton(totalAmount)}
          trend={<Trend value={amountVariation} variant="filled" />}
          icon={<EuroIcon />}
        />
        <RevenueCard
          title="Transactions"
          subTitle={getValueOrSkeleton(numberOfTransactions)}
          trend={<Trend value={transactionVariation} variant="filled" />}
          icon={<MoneyIcon />}
        />
        <RevenueCard
          title="Transaction moyenne"
          subTitle={getValueOrSkeleton(averageAmountPerTransaction)}
          trend={<Trend value={averageAmountPerTransactionVariation} variant="filled" />}
          icon={<TicketIcon className="include-stroke" />}
        />
        <RevenueCard
          title="Utilisateurs actifs"
          subTitle={getValueOrSkeleton(activeUsers)}
          trend={<Trend value={activeUsersVariation} variant="filled" />}
          icon={<UserIcon width={10} height={11} />}
        />
      </div>
      <div className="flex justify-between gap-4 h-[209px]">
        <AppPaymentChart
          title="Recettes de stationnement"
          subTitle={getValueOrSkeleton(totalAmount)}
          chartOptions={summaryChartOptions}
          className="flex-1 min-w-0"
        />

        {paymentMethodPieChartData && zoneNamePieChartData && userProfilesPieChartData && (
          <PieChartComponent
            charts={currentCity ? [paymentMethodChart, zoneNameChart, userProfilesPieChart] : [paymentMethodChart]}
            className="w-[28.375rem] flex-none"
          />
        )}
      </div>
      <TransactionTable />
    </div>
  );
};
